import { writable, derived } from 'svelte/store';

// Type definitions
type Language = 'en' | 'es';
type TranslationKey = 'User Profile' | 'First Name' | 'Last Name' | 'E-mail' | 'Phone Number' | 'Role' | 'Country' | 'Currency Code' | 'Referral' | 'Language' | 'Select a language'
                      | 'Add Group' | 'Name' | 'Parent-id' | 'Options' | 'Profile' | 'Transactions'| 'Sums' | 'Campaigns' | 'Rounds' | 'Game Servers' 
                      | 'Games' | 'Banners'| 'Administrators' | 'Cashiers' | 'Unassigned'|'Players' | 'Games Groups' | 'User Groups' | 'Logout' 
                      | 'Transaction' | 'real time update active' |'Start Date' | 'End Date' | 'Search by name' | '1 Week' | '2 Weeks' | '1 Month' 
                      | 'Summary by Type of Transaction' | 'Type of transaction' | 'Count'| 'Amount' | 'Total' | 'No transactions were found for the selected dates.' 
                      | 'Transaction List' | 'Transaction date' | 'Type' | 'User' |  'Balance' | 'Money Amount' | 'Money Balance' | 'Promo Amount' 
                      | 'Previous' | 'Page' | 'Next'| 'Total Promotion' | 'No promotion' | 'Groups' | 'Select All' | 'Loading' | 'Search' | 'No results found' 
                      | 'No data available for the selected period' | 'Transaction Summary' | 'Less' | 'More' | 'Deposit' | 'Withdraw' | 'Deposit Profit' | 'Bet'
                      | 'Win' | 'Profit' | 'End Round' | 'Cancel Bet' | 'Deposit Cancel' | 'Withdraw Cancel'| 'Game Counters' | 'Group Name' | 'Game Name' | 'Total Rounds' 
                      | 'Total Players' | 'Current' | 'No games data available' | 'Promotion Transactions Summary' | 'Promotional List' | 'Add Promo' 
                      | 'Promotion' | 'Descriptipn' | 'Active' | 'Total Days' | 'Expiration Date' |  'Inactive' | 'Edit Campaign' | 'Promotion Name' | 'Description'
                      | 'Enabled' | 'Cancel' | 'Update Campaign' | 'Add Server' | 'Label' | 'Username' | 'Password' | 'Endpoint' | 'Edit Game Server'| 'Update Server' 
                      | 'Add Game Server' | 'Adding...' | 'list of banners' | 'Add Banner' | 'Id' | 'Banner' | 'Link'| 'BigSelect' | 'SmallSelect'| 'No such server'
                      | 'Game code' | 'Group Current' | 'Assign' | 'Remove' | 'Imagen' | 'No groups assigned' | 'Save' | 'List of Games' | 'Add Game' | 'Game added successfully' 
                      | 'Print' | 'Dismiss' | 'Edit' | 'Edited successfully' | 'Select' | 'Existing imagen' | 'List of Managers' | 'Add Admin' | 'Group' | 'added successfully'
                      | 'Birthday' | 'YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY' | 'Add user' | 'Edit Admin' | 'Keep current password' | 'Set new password' | 'List of Cashiers'
                      | 'No such User' | 'No User found' | 'Unassigned Users' | 'No unassigned users found' | 'List of players' | 'Add player' | 'Promo' | 'No players found' 
                      | 'Trans Id' | 'Player Id' | 'Available Promotions' | 'Trans. date' | 'Trans. time' | 'Trans. type' | 'Trans. amount' | 'Promotion Balance' | 'New Group' 
                      | 'List of play groups' | 'Add play Group' | 'New Play Groups' | 'Play Group added successfully' | 'Are you sure you want to delete the group' | 'Select a group...'
                      | 'Added successfully' | 'Select a parent group...' | 'Player' | 'New' | 'Error' | 'Successful' | 'Withdraw failed' | 'Deposit completed with warnings' 
                      | 'does not exist' | 'Owner Permissions' | 'As an Owner, you can create subgroups under any existing group in the system.' | 'Available Groups' | 'You can assign users to your group and any subgroups under your hierarchy.' | 'As an Owner, you can assign users to any group in the system.' | 'Available Players' | 'You can see players from your group, parent group, and subgroups.' | 'As an Owner, you can see all players in the system.'
                      | 'User Transactions' | 'Back to Player List' | 'No Transactions' | 'No transactions found for this user' | 'Transaction ID' | 'Date' | 'Cashable Amount' | 'Cashable Balance' | 'Promo Balance'
                      | 'Country Code' | 'Currency Code' | 'Promo Initial Balance' | 'Start Date' | 'Expiration Date' | 'Campaign Type' | 'Promotion Name' | 'Description' | 'Start Amount' | 'Campaign ID'
                      | 'Details' | 'of' | 'transactions' | 'Items per page' | 'Withdraw Cashier' | 'Withdrawal Amount' | 'Pin' | 'Type of Transaction' | 'Applied Promotion'
                      | 'Promotions Details' | 'In Front Page' | 'Download Report' | 'Download Summary' | 'No transactions to export'
                      | 'LOGIN' | 'Email or Phone Number' | 'Password' | 'Sign In' | 'Signing in...' | 'Please complete the captcha verification.' | 'Captcha verification error. Please try again.' | 'Login error. Please try again.' | 'Connection error. Please try again.' 
                      | 'Daily Limit' | 'Transaction Limit' | 'Groups Limits' | 'Date Transaction' | 'Toggle Status' | 'Enable' | 'Disable' | 'Click to Disable' | 'Click to Enable' | 'View Transactions'
                      | 'Configuration' | 'Add Configuration' | 'Edit Configuration' | 'Key' | 'Value' | 'Select configuration key' | 'Configuration value' | 'Add' | 'Actions' | 'No configurations found' | 'System Information' | 'Total Configurations' | 'Last Updated' | 'Select value'
                      | 'List of Game Rounds' | 'Round of games' | 'Date result' | 'to' | 'Round Id' | 'Country code' | 'Round' | 'record' | 'List of Groups'
                      | 'Promotion Type' | 'Credit Amount' | 'Promotion Duration' | 'Days' | 'Hours' | 'Minutes' | 'Seconds' | 'Format'  | 'Deposit Required' | 'Enter promotion name' | 'Enter credit amount' | 'Register'  | 'Happy Friday' 
                      | 'Welcome' | 'Daily Bonus' | 'Manual' | 'Recharge' | 'Promotion Configuration' | 'Add Promotion' | 'Promotion' | 'Other Type' | 'Fixed Value' | 'Min Amount' | 'Max Amount' | 'Display Amount' | 'Add Range' | 'Remove Range' | 'Hide Configuration' | 'Show Advanced Configuration' | 'with ranges' 
                      | 'Promotion Ranges' | 'Fixed Amount' | 'Enter fixed amount'
                      | 'Add Group Limit' | 'Select group...' | 'Select user (optional)...' | 'Default selection:' | 'Initial Balance*' | 'Current Balance *' | 'Exito' 
                      | 'Usuario (Opcional)' | 'Grupo *' | 'Estado' | 'Determines whether the group limit is active or inactive.' |  'Add Limit' | 'ReportCashier' | 'Cashier Transaction Report' | 'Analysis of transactions by cashier' | 'Report Summary' | 'Period' | 'Cashier' | 'Debit' | 'Credit' | 'Multiple groups' | 'Player name...' | 'No Promotions'
                      | 'Enter the name of the promotion'| 'Enter the number of credits' | 'Active Status'| 'Duration of the promotion' | 'Configuration of Promotion'| 'Recharge (with Ranges)'|'Another type (fixed value)' | 'No configuration' | 'Back' | 'Limit of Group' | 'Limit information' | 'Group Id ' | 'User Id' | 'Initial Balance' | 'State' 
                      | 'Total transactions' | 'First Transaction' | 'Last Transaction' | 'Loading transactions...' | 'no transactions' | 'No transactions were found for this group limit.' | 'Transaction Ticket' | 'Group limit' | 'Group limit deleted successfully.' | 'Cannot apply promotions - Player has active promotions' | 'Player has active promotional balance'
                      | 'Selected group'| 'No groups selected' | 'All groups' | 'days' | 'day'| 'hours'|'hour'| 'minutes' | 'minute' | 'seconds' | 'second' | 'Undefined' | 'No date' | 'Invalid date'| 'No Configuration' | 'Settings error' | 'Ranges' | 'Tx per user' | 'Transactions per User' | 'View transaction summary for all users' | 'Upload Transaction Data' 
                      | 'Loading transaction data...' | 'Success' | 'Summary of Transactions per User' | 'Deposit Promo' | 'Withdraw Promo' | 'No transactions were found for the selected date range.' ;

// Translation object for Spanish translations
export const translations: Record<Language, Record<TranslationKey, string>> = {
    en: {
        "User Profile": "User Profile",
        "First Name": "First Name",
        "Last Name": "Last Name",
        "E-mail": "E-mail",
        "Phone Number": "Phone Number",
        "Role": "Role",
        "Country": "Country",
        "Currency Code": "Currency Code",
        "Referral": "Referral",
        "Language": "Language",
        "Select a language": "Select a language",
        "Add Group": "Add Group",
        "Name": "Name",
        "Parent-id": "Parent-id",
        "Options": "Options",
        "Profile": "Profile",
        "Transactions": "Transactions", 
        "Sums": "Sums",
        "Campaigns": "Campaigns",
        "Rounds": "Rounds",
        "Game Servers": "Game Servers",
        "Games": "Games",
        "Banners": "Banners",
        "Administrators": "Administrators",
        "Cashiers": "Cashiers",
        "Unassigned": "Unassigned",
        "Players": "Players",
        "Games Groups": "Games Groups",
        "User Groups": "User Groups",
        "Logout": "Logout",
        "Transaction": "Transaction",
        "real time update active": "real time update active",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Search by name": "Search by name",
        "1 Week": "1 Week",
        "2 Weeks": "2 Weeks",
        "1 Month": "1 Month",
        "Summary by Type of Transaction": "Summary by Type of Transaction",
        "Type of transaction": "Type of transaction",
        "Count": "Count",
        "Amount": "Amount",
        "Total": "Total",
        "No transactions were found for the selected dates.": "No transactions were found for the selected dates.",
        "Transaction List": "Transaction List",
        "Transaction date": "Transaction date",
        "Type": "Type",
        "User": "User",
        "Balance": "Balance",
        "Money Amount": "Money Amount",
        "Money Balance": "Money Balance",
        "Promo Amount": "Promo Amount",
        "Previous": "Previous",
        "Page": "Page",
        "Next": "Next",
        "Total Promotion": "Total Promotion",
        "No promotion": "No promotion",
        "Groups": "Groups",
        "Select All": "Select All",
        "Loading": "Loading",
        "Search": "Search",
        "No results found": "No results found",
        "No data available for the selected period": "No data available for the selected period",
        "Transaction Summary": "Transaction Summary",
        "Less": "Less",
        "More": "More",
        "Deposit": "Deposit",
        "Withdraw": "Withdraw",
        "Deposit Profit": "Profit",
        "Bet": "Bet",
        "Win": "Win",
        "Profit": "Profit",
        "End Round": "End Round",
        "Cancel Bet": "Cancel Bet",
        "Deposit Cancel": "Deposit Cancel",
        "Withdraw Cancel": "Withdraw Cancel",
        "Game Counters": "Game Counters",
        "Group Name": "Group Name",
        "Game Name": "Game Name",
        "Total Rounds": "Total Rounds",
        "Total Players": "Total Players",
        "Current": "Current",
        "No games data available": "No games data available",
        "Promotion Transactions Summary": "Promotion Transactions Summary",
        "Promotional List": "Promotional List",
        "Add Promo": "Add Promo",
        "Promotion": "Promotion",
        "Descriptipn": "Descriptipn",
        "Active": "Active",
        "Total Days": "Total Days",
        "Expiration Date": "Expiration Date",
        "Inactive": "Inactive",
        "Edit Campaign": "Edit Campaign",
        "Promotion Name": "Promotion Name",
        "Description": "Description",
        "Enabled": "Enabled",
        "Cancel": "Cancel",
        "Update Campaign": "Update Campaign",
        "Add Server": "Add Server",
        "Label": "Label",
        "Username": "Username",
        "Password": "Password",
        "Endpoint": "Endpoint",
        "Edit Game Server": "Edit Game Server",
        "Update Server": "Update Server",
        "Add Game Server": "Add Game Server",
        "Adding...": "Adding...",
        "list of banners": "list of banners",
        "Add Banner": "Add Banner",
        "Id": "Id",
        "Banner": "Banner",
        "Link": "Link",
        "BigSelect": "BigSelect",
        "SmallSelect": "SmallSelect",
        "No such server": "No such server",
        "Game code": "Game code",
        "Group Current": "Group Current",
        "Assign": "Assign",
        "Remove": "Remove",
        "Imagen": "Image",
        "No groups assigned": "No groups assigned",
        "Save": "Save",
        "List of Games": "List of Games",
        "Add Game": "Add Game",
        "Game added successfully": "Game added successfully",
        "Print": "Print",
        "Dismiss": "Dismiss",
        "Edit": "Edit",
        "Edited successfully": "Edited successfully",
        "Select": "Select",
        "Existing imagen": "Existing imagen",
        "List of Managers": "List of Admins",
        "Add Admin": "Add Admin",
        "Group": "Group",
        "added successfully": "Added successfully",
        "Birthday": "Birthday",
        "YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY": "your reference will be assigned automatically",
        "Add user": "Add user",
        "Edit Admin": "Edit Admin",
        "Keep current password": "Keep current password",
        "Set new password": "Set new password",
        "List of Cashiers": "List of Cashiers",
        "No such User": "No such User",
        "No User found": "No User found",
        "Unassigned Users": "Unassigned Users",
        "No unassigned users found": "No unassigned users found",
        "List of players": "List of players",
        "Add player": "Add player",
        "Promo": "Promo",
        "No players found": "No players found",
        "Trans Id": "Trans Id",
        "Player Id": "Player Id",
        "Available Promotions": "Available Promotions",
        "Trans. date": "Trans. date",
        "Trans. time": "Trans. time",
        "Trans. type": "Trans. type",
        "Trans. amount": "Trans. amount",
        "Promotion Balance": "Promotion Balance",
        "New Group": "New Group",
        "List of play groups": "List of play groups",
        "Add play Group": " Add play Group",
        "New Play Groups": "New Play Groups",
        "Play Group added successfully": "Play Group added successfully",
        "Are you sure you want to delete the group": "Are you sure you want to delete the group",
        "Select a group...": "Select a group...",
        "Added successfully": "Added successfully",
        "Select a parent group...": "Select a parent group...",
        "Player": "Player",
        "New": "New",
        "Error": "Error",
        "Successful": "Successful",
        "Withdraw failed": "Withdraw failed",
        "Deposit completed with warnings": "Deposit completed with warnings",
        "does not exist": "does not exist",
        "Owner Permissions": "Owner Permissions",
        "As an Owner, you can create subgroups under any existing group in the system.": "As an Owner, you can create subgroups under any existing group in the system.",
        "Available Groups": "Available Groups",
        "You can assign users to your group and any subgroups under your hierarchy.": "You can assign users to your group and any subgroups under your hierarchy.",
        "As an Owner, you can assign users to any group in the system.": "As an Owner, you can assign users to any group in the system.",
        "Available Players": "Available Players",
        "You can see players from your group, parent group, and subgroups.": "You can see players from your group, parent group, and subgroups.",
        "As an Owner, you can see all players in the system.": "As an Owner, you can see all players in the system.",
        "User Transactions": "User Transactions",
        "Back to Player List": "Back to Player List",
        "No Transactions": "No Transactions",
        "No transactions found for this user": "No transactions found for this user",
        "Transaction ID": "Transaction ID",
        "Date": "Date",
        "Cashable Amount": "Cashable Amount",
        "Cashable Balance": "Cashable Balance",
        "Promo Balance": "Promo Balance",
        "Country Code": "Country Code",
        "Promo Initial Balance": "Promo Initial Balance",
        "Campaign Type": "Campaign Type",
        "Start Amount": "Start Amount",
        "Campaign ID": "Campaign ID",
        "Details": "Details",
        "of": "of",
        "transactions": "transactions",
        "Items per page": "Items per page",
        "Withdraw Cashier": "Withdraw Cashier",
        "Withdrawal Amount": "Withdrawal Amount",
        "Pin": "Pin",
        "Type of Transaction": "Type of Transaction",
        "Applied Promotion": "Applied Promotion",
        "Promotions Details": "Promotions Details",
        "In Front Page": "In Front Page",
        "Download Report": "Download Report",
        "Download Summary": "Download Summary",
        "No transactions to export": "No transactions to export",
        "LOGIN": "LOGIN",
        "Email or Phone Number": "Email or Phone Number",
        "Sign In": "Sign In",
        "Signing in...": "Signing in...",
        "Please complete the captcha verification.": "Please complete the captcha verification.",
        "Captcha verification error. Please try again.": "Captcha verification error. Please try again.",
        "Login error. Please try again.": "Login error. Please try again.",
        "Connection error. Please try again.": "Connection error. Please try again.",
        "Daily Limit": "Daily Limit",
        "Transaction Limit": "Transaction Limit",
        "Groups Limits": "Groups Limits",
        "Date Transaction": "Date Transaction",
        "Toggle Status": "Toggle Status",
        "Enable": "Enable",
        "Disable": "Disable",
        "Click to Disable": "Click to Disable",
        "Click to Enable": "Click to Enable",
        "View Transactions": "View Transactions",
        "Configuration": "Configuration",
        "Add Configuration": "Add Configuration",
        "Edit Configuration": "Edit Configuration",
        "Key": "Key",
        "Value": "Value",
        "Select configuration key": "Select configuration key",
        "Configuration value": "Configuration value",
        "Add": "Add",
        "Actions": "Actions",
        "No configurations found": "No configurations found",
        "System Information": "System Information",
        "Total Configurations": "Total Configurations",
        "Last Updated": "Last Updated",
        "Select value": "Select value",
        "List of Game Rounds": "List of Game Rounds",
        "Round of games": "Round of games",
        "Date result": "Date result",
        "to": "to",
        "Round Id": "Round Id",
        "Country code": "Country code",
        "Round": "Round",
        "record": "record",
        "List of Groups": "List of Groups",
        "Add Promotion": "Add Promotion",
        "Promotion Type": "Promotion Type",
        "Credit Amount": "Credit Amount",
        "Promotion Duration": "Promotion Duration",
        "Days": "Days",
        "Hours": "Hours",
        "Minutes": "Minutes",
        "Seconds": "Seconds",
        "Format": "Format",
        "Deposit Required": "Deposit Required",
        "Enter promotion name": "Enter promotion name",
        "Enter credit amount": "Enter credit amount",
        "Register": "Register",
        "Happy Friday": "Happy Friday",
        "Welcome": "Welcome",
        "Daily Bonus": "Daily Bonus",
        "Manual": "Manual",
        "Recharge": "Recharge",
        "Promotion Configuration": "Promotion Configuration",
        "Other Type": "Other Type",
        "Fixed Value": "Fixed Value",
        "Min Amount": "Min Amount",
        "Max Amount": "Max Amount",
        "Display Amount": "Display Amount",
        "Add Range": "Add Range",
        "Remove Range": "Remove Range",
        "Hide Configuration": "Hide Configuration",
        "Show Advanced Configuration": "Show Advanced Configuration",
        "with ranges": "with ranges",
        "Promotion Ranges": "Promotion Ranges",
        "Fixed Amount": "Fixed Amount",
        "Enter fixed amount": "Enter fixed amount",
        "Add Group Limit": "Add Group Limit",
        "Select group...": "Select group...",
        "Select user (optional)...": "Select user (optional)...",
        "Default selection:": "Default selection:",
        "Initial Balance*": "Initial Balance*",
        "Current Balance *": "Current Balance *",
        "Exito": "Success",
        "Usuario (Opcional)": "User (optional)",
        "Grupo *": "Group *",
        "Estado": "Status",
        "Determines whether the group limit is active or inactive." : "Determines whether the group limit is active or inactive.",
        "Add Limit": "Add Limit",
        "ReportCashier": "Report Cashier",
        "Cashier Transaction Report": "Cashier Transaction Report",
        "Analysis of transactions by cashier": "Analysis of transactions by cashier",
        "Report Summary": "Report Summary",
        "Period": "Period",
        "Cashier": "Cashier",
        "Debit": "Debit",
        "Credit": "Credit",
        "Multiple groups": "Multiple groups",
        "Player name...": "Player name...",
        "No Promotions": "No Promotions",
        "Enter the name of the promotion": "Enter the name of the promotion",
        "Enter the number of credits": "Enter the number of credits",
        "Active Status": "Active Status",
        "Duration of the promotion": "Duration of the promotion",
        "Configuration of Promotion": "Configuration of Promotion",
        "Recharge (with Ranges)": "Recharge (with Ranges)",
        "Another type (fixed value)": "Another type (fixed value)",
        "No configuration": "No configuration",
        "Back": "Back",
        "Limit of Group": "Limit of Group",
        "Limit information": "Limit information",
        "Group Id ": "Group Id ",
        "User Id": "User Id",
        "Initial Balance": "Initial Balance",
        "State": "State",
        "Total transactions": "Total transactions",
        "First Transaction": "First Transaction",
        "Last Transaction": "Last Transaction",
        "Loading transactions...": "Loading transactions...",
        "no transactions": "No transactions",
        "No transactions were found for this group limit.": "No transactions were found for this group limit.",
        "Transaction Ticket": "Transaction Ticket",
        "Group limit": "Group limit",
        "Group limit deleted successfully.": "Group limit deleted successfully.",
        "Cannot apply promotions - Player has active promotions": "Cannot apply promotions - Player has active promotions",
        "Player has active promotional balance": "Player already has active recharge promo",
        "Selected group": "Selected group",
        "No groups selected": "No groups selected",
        "All groups": "All groups",
        "days": "days",
        "day": "day",
        "hours": "hours",
        "hour": "hour",
        "minutes": "minutes",
        "minute": "minute",
        "seconds": "seconds",
        "second": "second",
        "Undefined": "Undefined",
        "No date": "No date",
        "Invalid date": "Invalid date",
        "No Configuration": "No Configuration",
        "Settings error": "Settings error",
        "Ranges": "Ranges",
        "Tx per user": "Tx per user",
        "Transactions per User" : "Transactions per User",
        "View transaction summary for all users": "View transaction summary for all users",
        "Upload Transaction Data": "Upload Transaction Data",
        "Loading transaction data...": "Loading transaction data...",
        "Success": "Success",
        "Summary of Transactions per User": "Summary of Transactions per User",
        "Deposit Promo": "Deposit Promo",
        "Withdraw Promo": "Withdraw Promo",
        "No transactions were found for the selected date range.": "No transactions were found for the selected date range."

    },
    es: {
        "User Profile": "Perfil de Usuario",
        "First Name": "Nombre",
        "Last Name": "Apellido",
        "E-mail": "Correo electrónico",
        "Phone Number": "Número de teléfono",
        "Role": "Rol",
        "Country": "País",
        "Currency Code": "Código de moneda",
        "Referral": "Referencia",
        "Language": "Idioma",
        "Select a language": "Seleccione un idioma",
        "Add Group": "Agregar Grupo",
        "Name": "Nombre",
        "Parent-id": "Grupo principal",
        "Options": "Opciones",
        "Profile": "Perfil",
        "Transactions": "Transacciones",
        "Sums": "Sumas",
        "Campaigns": "Campañas",
        "Rounds": "Rondas",
        "Game Servers": "Servidores de juegos",
        "Games": "Juegos",
        "Banners": "Banners",
        "Administrators": "Administradores",
        "Cashiers": "Cajeros",
        "Unassigned": "Sin asignar",
        "Players": "Jugadores",
        "Games Groups": "Grupos de juegos",
        "User Groups": "Grupos de usuarios",
        "Logout": "Cerrar sesión",
        "Transaction": "Transacción",
        "real time update active": "actualización en tiempo real activa",
        "Start Date": "Fecha de inicio",
        "End Date": "Fecha de fin",
        "Search by name": "Buscar por nombre",
        "1 Week": "1 Semana",
        "2 Weeks": "2 Semanas",
        "1 Month": "1 Mes",
        "Summary by Type of Transaction": "Resumen por tipo de transacción",
        "Type of transaction": "Tipo de transacción",
        "Count": "Conteo",
        "Amount": "Cantidad",
        "Total": "Total",
        "No transactions were found for the selected dates.": "No se encontraron transacciones para los datos seleccionados.",
        "Transaction List": "Lista de transacciones",
        "Transaction date": "Fecha de transacción",
        "Type": "Tipo",
        "User": "Usuario",
        "Balance": "Balance",
        "Money Amount": "Cantidad de dinero",
        "Money Balance": "Balance de dinero",
        "Promo Amount": "Promoción",
        "Previous": "Anterior",
        "Page": "Página",
        "Next": "Siguiente",
        "Total Promotion": "Promoción total",
        "No promotion": "Sin promoción",
        "Groups": "Grupos",
        "Select All": "Seleccionar todo",
        "Loading": "Cargando",
        "Search": "Buscar",
        "No results found": "No se encontraron resultados",
        "No data available for the selected period": "No hay datos disponibles para el periodo seleccionado",
        "Transaction Summary": "Resumen de transacciones",
        "Less": "Menos",
        "More": "Más",
        "Deposit": "Depósito",
        "Withdraw": "Retiro",
        "Deposit Profit": "Profit",
        "Bet": "Apuesta",
        "Win": "Ganancia",
        "Profit": "Profit",
        "End Round": "Ronda",
        "Cancel Bet": "Apuesta cancelalda",
        "Deposit Cancel": "Deposito cancelado",
        "Withdraw Cancel": "Cobro cancelaldo",
        "Game Counters": "Contadore de juegos",
        "Group Name": "Nombre del grupo",
        "Game Name": "Nombre del juego",
        "Total Rounds": "Total de rondas",
        "Total Players": "Total de jugadores",
        "Current": "Actual",
        "No games data available": "No hay datos de juegos disponibles",
        "Promotion Transactions Summary": "Resumen de transacciones de promoción",
        "Promotional List": "Lista de promociones",
        "Add Promo": "Agregar Promo",
        "Promotion": "Promoción",
        "Descriptipn": "Descripción",
        "Active": "Estatus",
        "Total Days": "Tiempo de Promoción",
        "Expiration Date": "Fecha de Expiración",
        "Inactive": "Inactivo", 
        "Edit Campaign": "Editar campaña",
        "Promotion Name": "Nombre de promoción",
        "Description": "Descripción",
        "Enabled": "Habilitado",
        "Cancel": "Cancelar",
        "Update Campaign": "Actualizar campaña",
        "Add Server": "Agregar servidor",
        "Label": "Etiqueta",
        "Username": "Nombre de servidor",
        "Password": "Contraseña",
        "Endpoint": "Url de servidor",
        "Edit Game Server": "Editar servidor de juego",
        "Update Server": "Actualizar servidor",
        "Add Game Server": "Agregar servidor de juego",
        "Adding...": "Agregando...",
        "list of banners": "lista de banners",
        "Add Banner": "Agregar Banner",
        "Id": "Id",
        "Banner": "Banner",
        "Link": "Enlace",
        "BigSelect": "BigSelect",
        "SmallSelect": "SmallSelect",
        "No such server": "No existe ese servidor",
        "Game code": "Código de juego",
        "Group Current": "Grupo actual",
        "Assign": "Asignar",
        "Remove": "Eliminar",
        "Imagen": "Imagen",
        "No groups assigned": "No hay grupos asignados",
        "Save": "Guardar",
        "List of Games": "Lista de juegos",
        "Add Game": "Agregar juego",
        "Game added successfully": "Juego agregado correctamente",
        "Print": "Imprimir",
        "Dismiss": "Descartar",
        "Edit": "Editar",
        "Edited successfully": "Editado correctamente",
        "Select": "Seleccionar",
        "Existing imagen": "Imagen existente",
        "List of Managers": "Lista de administradores",
        "Add Admin": "Agregar administrador",
        "Group": "Grupo",
        "added successfully": "Agregado correctamente",
        "Birthday": "Fecha de nacimiento",
        "YOUR REFERENCE WILL BE ASSIGNED AUTOMATICALLY": "Su referencia se asignará automáticamente",
        "Add user": "Agregar usuario",
        "Edit Admin": "Editar administrador",
        "Keep current password": "Mantener contraseña actual",
        "Set new password": "Establecer nueva contraseña",
        "List of Cashiers": "Lista de Cajeros",
        "No such User": "No existe ese usuario",
        "No User found": "No se encontraro usuario",
        "Unassigned Users": "Usuarios sin asignar",
        "No unassigned users found": "No se encontraron usuarios sin asignar",
        "List of players": "Lista de jugadores",
        "Add player": "Agregar jugador",
        "Promo": "Promoción",
        "No players found": "No se encontro jugador",
        "Trans Id": "Id de transacción",
        "Player Id": "Id de jugador",
        "Available Promotions": "Promociones disponibles",
        "Trans. date": "Fecha de transacción",
        "Trans. time": "Hora de transacción",
        "Trans. type": "Tipo de transacción",
        "Trans. amount": "Cantidad de transacción",
        "Promotion Balance": "Balance de promoción",
        "New Group": "Nuevo grupo",
        "List of play groups": "Lista de grupos de juegos",
        "Add play Group": " Agregar grupo de juegos",
        "New Play Groups": "Nuevo grupo de juegos",
        "Play Group added successfully": "Grupo de juegos agregado correctamente",
        "Are you sure you want to delete the group": "¿Está seguro de que desea eliminar el grupo",
        "Select a group...": "Seleccione un grupo...",
        "Added successfully": "Agregado correctamente",
        "Select a parent group...": "Seleccione un grupo padre...",
        "Player": "Jugador",
        "New": "Nuevo",
        "Error": "Error",
        "Successful": "Exitoso",
        "Withdraw failed": "Retiro fallido",
        "Deposit completed with warnings": "Depósito completado con advertencias",
        "does not exist": "no existe",
        "Owner Permissions": "Permisos de Propietario",
        "As an Owner, you can create subgroups under any existing group in the system.": "Como Propietario, puede crear subgrupos bajo cualquier grupo existente en el sistema.",
        "Available Groups": "Grupos Disponibles",
        "You can assign users to your group and any subgroups under your hierarchy.": "Puede asignar usuarios a su grupo y cualquier subgrupo bajo su jerarquía.",
        "As an Owner, you can assign users to any group in the system.": "Como Propietario, puede asignar usuarios a cualquier grupo en el sistema.",
        "Available Players": "Jugadores Disponibles",
        "You can see players from your group, parent group, and subgroups.": "Puede ver jugadores de su grupo, grupo padre y subgrupos.",
        "As an Owner, you can see all players in the system.": "Como Propietario, puede ver todos los jugadores en el sistema.",
        "User Transactions": "Transacciones de Usuario",
        "Back to Player List": "Volver a Lista de Jugadores",
        "No Transactions": "Sin Transacciones",
        "No transactions found for this user": "No se encontraron transacciones para este usuario",
        "Transaction ID": "ID de Transacción",
        "Date": "Fecha",
        "Cashable Amount": "Movimientos",
        "Cashable Balance": "Total",
        "Promo Balance": "Balance de Promoción",
        "Country Code": "Código de País",
        "Promo Initial Balance": "Balance Inicial de Promo",
        "Campaign Type": "Tipo de Campaña",
        "Start Amount": "Cantidad Inicial",
        "Campaign ID": "ID de Campaña",
        "Details": "Detalles",
        "of": "de",
        "transactions": "transacciones",
        "Items per page": "Elementos por página",
        "Withdraw Cashier": "Retiro de Cajero",
        "Withdrawal Amount": "Cantidad de Retiro",
        "Pin": "Código de Retiro",
        "Type of Transaction": "Tipo de Transacción",
        "Applied Promotion": "Promoción Aplicada",
        "Promotions Details": "Detalles de Promociones",
        "In Front Page": "En página principal",
        "Download Report": "Descargar Reporte",
        "Download Summary": "Descargar Resumen",
        "No transactions to export": "No hay transacciones para exportar",
        "LOGIN": "INICIAR SESIÓN",
        "Email or Phone Number": "Correo Electrónico o Número de Teléfono",
        "Sign In": "Iniciar Sesión",
        "Signing in...": "Iniciando sesión...",
        "Please complete the captcha verification.": "Por favor, completa la verificación del captcha.",
        "Captcha verification error. Please try again.": "Error en la verificación del captcha. Por favor, inténtalo de nuevo.",
        "Login error. Please try again.": "Error al iniciar sesión. Por favor, inténtalo de nuevo.",
        "Connection error. Please try again.": "Error de conexión. Por favor, inténtalo de nuevo.",
        "Daily Limit": "Límite diario",
        "Transaction Limit": "Límite de transacción",
        "Groups Limits": "Límites de grupos",
        "Date Transaction": "Fecha de Transacción",
        "Toggle Status": "Cambiar Estado",
        "Enable": "Habilitar",
        "Disable": "Deshabilitar",
        "Click to Disable": "Clic para Deshabilitar",
        "Click to Enable": "Clic para Habilitar",
        "View Transactions": "Ver Transacciones",
        "Configuration": "Configuración",
        "Add Configuration": "Agregar Configuración",
        "Edit Configuration": "Editar Configuración",
        "Key": "Clave",
        "Value": "Valor",
        "Select configuration key": "Seleccionar clave de configuración",
        "Configuration value": "Valor de configuración",
        "Add": "Agregar",
        "Actions": "Acciones",
        "No configurations found": "No se encontraron configuraciones",
        "System Information": "Información del Sistema",
        "Total Configurations": "Total de Configuraciones",
        "Last Updated": "Última Actualización",
        "Select value": "Seleccionar valor",
        "List of Game Rounds": "Lista de Rondas de Juego",
        "Round of games": "Rondas de juegos",
        "Date result": "Resultado de fecha",
        "to": "a",
        "Round Id": "Id de Ronda",
        "Country code": "Código de país",
        "Round": "Ronda",
        "record": "registro",
        "List of Groups": "Lista de Grupos",
        "Add Promotion": "Agregar Promoción",
        "Promotion Type": "Tipo de Promoción",
        "Credit Amount": "Cantidad de Créditos",
        "Promotion Duration": "Duración de la Promoción",
        "Days": "Días",
        "Hours": "Horas",
        "Minutes": "Minutos",
        "Seconds": "Segundos",
        "Format": "Formato",
        "Deposit Required": "Depósito Requerido",
        "Enter promotion name": "Ingrese el nombre de la promoción",
        "Enter credit amount": "Ingrese la cantidad de créditos",
        "Register": "Registro",
        "Happy Friday": "Viernes Feliz",
        "Welcome": "Bienvenida",
        "Daily Bonus": "Bono Diario",
        "Manual": "Manual",
        "Recharge": "Recarga",
        "Promotion Configuration": "Configuración de Promociones",
        "Other Type": "Otro tipo",
        "Fixed Value": "Valor fijo",
        "Min Amount": "Monto Mínimo",
        "Max Amount": "Monto Máximo",
        "Display Amount": "Monto a Mostrar",
        "Add Range": "Agregar Rango",
        "Remove Range": "Eliminar Rango",
        "Hide Configuration": "Ocultar Configuración",
        "Show Advanced Configuration": "Mostrar Configuración Avanzada",
        "with ranges": "con rangos",
        "Promotion Ranges": "Rangos de Promoción",
        "Fixed Amount": "Monto Fijo",
        "Enter fixed amount": "Ingrese el monto fijo",
        "Add Group Limit": "Agregar Límite de Grupo",
        "Select group...": "Seleccionar grupo...",
        "Select user (optional)...": "Seleccionar usuario (opcional)...",
        "Default selection:": "Selección predeterminada:",
        "Initial Balance*": "Balance Inicial*",
        "Current Balance *": "Balance Actual *",
        "Exito": "Success",
        "Usuario (Opcional)": "Usuario (opcional)",
        "Grupo *": "Grupo *",
        "Estado": "Estado",
        "Determines whether the group limit is active or inactive.": "Determina si el límite de grupo está activo o inactivo.",
        "Add Limit": "Agregar Límite",
        "ReportCashier": "Reporte de Cajero",
        "Cashier Transaction Report": "Reporte de Transacciones por Cajero",
        "Analysis of transactions by cashier": "Análisis de transacciones por cajero",
        "Report Summary": "Resumen del Reporte",
        "Period": "Período",
        "Cashier": "Cajero",
        "Debit": "Apuesta",
        "Credit": "Ganancia",
        "Multiple groups": "Múltiples grupos",
        "Player name...": "Nombre del jugador...",
        "No Promotions": "Sin promociones",
        "Enter the name of the promotion": "Ingrese el nombre de la promoción",
        "Enter the number of credits": "Ingrese el número de créditos",
        "Active Status": "Estado Activo",
        "Duration of the promotion": "Duración de la promoción",
        "Configuration of Promotion": "Configuración de Promoción",
        "Recharge (with Ranges)": "Recarga (con rangos)",
        "Another type (fixed value)": "Otro tipo (valor fijo)",
        "No configuration": "No hay configuración",
        "Back": "Atrás",
        "Limit of Group": "Límite de Grupo",
        "Limit information": "Información del Límite",
        "Group Id ": "Id del Grupo",
        "User Id": "Id del Usuario",
        "Initial Balance": "Balance Inicial",
        "State": "Estado",
        "Total transactions": "Total de transacciones",
        "First Transaction": "Primera Transacción",
        "Last Transaction": "Última Transacción",
        "Loading transactions...": "Cargando transacciones...",
        "no transactions": "Sin transacciones",
        "No transactions were found for this group limit.": "No se encontraron transacciones para este límite de grupo.",
        "Transaction Ticket": "Ticket de Transacción",
        "Group limit": "Límite de grupo",
        "Group limit deleted successfully.": "Límite de grupo eliminado exitosamente.",
        "Cannot apply promotions - Player has active promotions": "No se pueden aplicar promociones - El jugador tiene promociones activas",
        "Player has active promotional balance": "El jugador tiene activo saldo de recarga",
        "Selected group": "Grupo seleccionado",
        "No groups selected": "No se seleccionaron grupos",
        "All groups": "Todos los grupos",
        "days": "días",
        "day": "día",
        "hours": "horas",
        "hour": "hora",
        "minutes": "minutos",
        "minute": "minuto",
        "seconds": "segundos",
        "second": "segundo",
        "Undefined": "Indefinido",
        "No date": "Sin fecha",
        "Invalid date": "Fecha inválida",
        "No Configuration": "Sin configuración",
        "Settings error": "Error de configuración",
        "Ranges": "Rangos",
        "Tx per user": "Tx por usuario",
        "Transactions per User": "Transacciones por usuario",
        "View transaction summary for all users": "Ver resumen de transacciones para todos los usuarios",
        "Upload Transaction Data": "Cargar datos de transacción",
        "Loading transaction data...": "Cargando datos de transacción...",
        "Success": "Éxito",
        "Summary of Transactions per User": "Resumen de transacciones por usuario",
        "Deposit Promo": "Depósito Promo",
        "Withdraw Promo": "Retiro Promo",
        "No transactions were found for the selected date range.": "No se encontraron transacciones para el rango de fechas seleccionado."
    }
};

// Current language store (default to English)
export const currentLanguage = writable<Language>('en');

// Function to set the current language
export function setLanguage(lang: Language) {
    currentLanguage.set(lang);
}

// Reactive translate function
export function createTranslate() {
    return derived(currentLanguage, ($currentLanguage) => {
        return (text: TranslationKey): string => {
            return translations[$currentLanguage][text] || text;
        };
    });
}

// Export the reactive translate function
export const translate = createTranslate();

// Function to get current language
export function getCurrentLanguage(): Language {
    let lang: Language = 'en';
    currentLanguage.subscribe(value => {
        lang = value;
    })();
    return lang;
}
